/* URNIETA collection JS — auto-submit filter form on input change.
   Vanilla, ~1 KB target. */
(function() {
  'use strict';
  const form = document.getElementById('urn-filter-form');
  if (!form) return;

  // Auto-submit on any change. Debounce price-range numeric inputs.
  let priceTimeout = null;
  form.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.type === 'number') return;  // wait for blur or debounced input
    submitFilters();
  });
  form.addEventListener('input', (e) => {
    if (e.target && e.target.type === 'number') {
      clearTimeout(priceTimeout);
      priceTimeout = setTimeout(submitFilters, 600);
    }
  });

  function submitFilters() {
    // Build query string from form. Skip empty values; preserve sort.
    const fd = new FormData(form);
    const qs = new URLSearchParams();
    for (const [k, v] of fd.entries()) {
      if (v && v !== '') qs.append(k, v);
    }
    const url = location.pathname + (qs.toString() ? '?' + qs.toString() : '');
    location.href = url;
  }
})();
